export default __webpack_public_path__ + "static/media/Dibyanshu_Sharma.0b9a9749.jpg";